import { useModalStore } from '@/store/useModal'
import { ModalsRegisterPatient } from '../../../RegisterPatient.constants'

const useEligibilityCheckModal = () => {
  const { modalOpen, closeModal, showModal } = useModalStore()
  const opened = modalOpen === ModalsRegisterPatient.ELIGIBILITY_CHECK
  const handleEligibilityCheckModal = () => {
    showModal(ModalsRegisterPatient.ELIGIBILITY_CHECK)
  }

  return {
    modalOpen,
    closeModal,
    handleEligibilityCheckModal,
    opened,
  }
}

export default useEligibilityCheckModal
